import { StyleSheet, Dimensions } from 'react-native'
import theme from '../../../theme'

const { width } = Dimensions.get('window')

const styles = StyleSheet.create({
    container: {
        flex: 1,
        backgroundColor: 'white',
    },
    containerRow: {
        flexDirection: 'row',
        alignItems: 'center',
    },
    containerNoPeriod: {
        flex: 1,
        backgroundColor: 'white',
        justifyContent: 'center',
        alignItems: 'center',
    },
    imageNoPeriod: {
        width: 120,
        height: 120,
    },
    titleNoPeriod: {
        fontSize: 18,
        fontWeight: 'bold',
        color: theme.colors.textPrimary,
        textAlign: 'center',
        marginBottom: 5,
        marginTop: 10,
        paddingHorizontal: 30,
    },
    descriptionNoPeriod: {
        fontSize: 16,
        fontWeight: 'normal',
        color: theme.colors.textSecondary,
        textAlign: 'center',
        paddingHorizontal: 40,
    },
    title: {
        fontSize: 18,
        fontWeight: 'bold',
        color: theme.colors.textPrimary,
        marginHorizontal: 12,
    },
    titleModal: {
        fontSize: 16,
        fontWeight: 'bold',
        color: theme.colors.textPrimary,
        marginHorizontal: 12,
    },
    subtitle: {
        fontSize: 14,
        fontWeight: 'normal',
        color: theme.colors.textSecondary,
        marginLeft: 12,
    },
    number: {
        fontSize: 16,
        fontWeight: 'bold',
        color: theme.colors.textSecondary,
    },
    progressBar: {
        borderRadius: 6,
        borderColor: 'transparent',
        marginHorizontal: 12,
    },
    containerFinder: {
        flexDirection: 'row',
        paddingHorizontal: 10,
    },
    inputBlock: {
        flex: 1,
        flexDirection: 'row',
        width: '100%',
        height: 40,
        borderWidth: 0.5,
        borderRadius: 10,
        borderColor: theme.colors.mediumGray,
        backgroundColor: 'white',
        alignItems: 'center',
        alignContent: 'center',
        justifyContent: 'space-between',
        paddingHorizontal: 20,
        marginVertical: 10,
        marginRight: 15,
    },
    input: {
        flex: 1,
        fontSize: 15,
        color: theme.colors.textPrimary,
    },
    textFilter: {
        fontSize: 16,
        fontWeight: 'bold',
        color: theme.colors.colorPrimary,
        marginRight: 6,
    },
    checkboxButton: {
        marginLeft: 10,
    },
    checkboxSelected: {
        width: 20,
        height: 20,
        backgroundColor: theme.colors.colorPrimary,
        borderWidth: 1.5,
        borderRadius: 5,
        borderColor: theme.colors.colorPrimary,
    },
    checkboxUnselected: {
        width: 20,
        height: 20,
        backgroundColor: 'white',
        borderWidth: 1.5,
        borderRadius: 5,
        borderColor: theme.colors.textPrimary,
    },
    cardContainer: {
        flex: 1,
        flexDirection: 'row',
        borderWidth: 1,
        borderColor: theme.colors.lightGray,
        padding: 10,
        borderRadius: 8,
        marginTop: 12,
        marginHorizontal: 12,
        justifyContent: 'space-between',
    },
    header: {
        flexDirection: 'row',
        alignItems: 'center',
        marginBottom: 5,
    },
    image: {
        width: 25,
        height: 25,
        borderRadius: 15,
        overflow: 'hidden',
        transform: [{ scale: 1.0 }],
    },
    headerText: {
        fontSize: 16,
        fontWeight: 'bold',
        color: theme.colors.textPrimary,
        marginLeft: 6,
    },
    containerOption: {
        flexDirection: 'row',
        alignItems: 'center',
        marginBottom: 8,
    },
    optionText: {
        fontSize: 14,
        fontWeight: 'normal',
        color: theme.colors.textPrimary,
        marginLeft: 6,
    },
    infoContainer: {
        flexDirection: 'row',
        alignItems: 'center',
        marginBottom: 5,
    },
    containerData: {
        flexDirection: 'row',
        alignItems: 'center',
        marginEnd: 12,
    },
    separator: {
        color: theme.colors.textSecondary,
    },
    infoText: {
        fontSize: 12,
        color: theme.colors.textSecondary,
        marginHorizontal: 4,
    },
    storecode: {
        fontSize: 12,
        fontWeight: 'bold',
        color: theme.colors.textSecondary,
    },
    addressText: {
        fontSize: 14,
        fontWeight: 'normal',
        color: theme.colors.textSecondary,
    },
    activityText: {
        fontSize: 14,
        color: theme.colors.colorPrimary,
        fontWeight: 'bold',
    },
    imageAsset: {
        width: 120,
        height: 120,
        alignSelf: 'center',
    },
    titleText: {
        fontSize: 18,
        fontWeight: 'bold',
        color: theme.colors.textPrimary,
        textAlign: 'center',
        marginBottom: 5,
        marginTop: 10,
        paddingHorizontal: 12,
    },
    descriptionText: {
        fontSize: 16,
        fontWeight: 'normal',
        color: theme.colors.textSecondary,
        textAlign: 'center',
        paddingHorizontal: 12,
    },
    button: {
        backgroundColor: theme.colors.createScheduleBackgroundColor,
        padding: 10,
        borderRadius: 5,
        alignItems: 'center',
    },
    buttonText: {
        color: '#FFFFFF',
        fontWeight: 'bold',
    },
    icon: {
        alignSelf: 'center',
    },
    statusModuleList: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        alignContent: 'center',
        marginVertical: 2,
        paddingHorizontal: 8,
        paddingVertical: 4,
        borderRadius: 5,
        alignSelf: 'flex-start',
    },
    statusModuleText: {
        fontSize: 12,
        fontWeight: 'bold',
        textAlign: 'center',
    },
    buttonContainer: {
        flexDirection: 'column',
        position: 'absolute',
        paddingVertical: 15,
        bottom: 15,
        width: '100%',
    },
    mainButton: {
        marginTop: 10,
        backgroundColor: theme.colors.colorPrimary,
        padding: 10,
        borderRadius: 10,
        marginHorizontal: 10,
    },
    mainButtonDisabled: {
        marginTop: 10,
        backgroundColor: theme.colors.lightGray,
        padding: 10,
        borderRadius: 10,
        marginHorizontal: 10,
    },
    mainButtonText: {
        fontSize: 16,
        color: 'white',
        fontWeight: 'bold',
        textAlign: 'center',
    },
    mainButtonTextDisabled: {
        fontSize: 16,
        color: theme.colors.textSecondary,
        fontWeight: 'bold',
        textAlign: 'center',
    },
    borderButton: {
        margin: 12,
        backgroundColor: 'white',
        borderWidth: 2,
        borderColor: theme.colors.colorPrimary,
        padding: 8,
        borderRadius: 10,
    },
    borderButtonText: {
        fontSize: 16,
        color: theme.colors.colorPrimary,
        fontWeight: 'bold',
        textAlign: 'center',
    },
    margin: { margin: 12 },
    marginTop: { marginTop: 8 },
    spacer1: {
        height: 4,
    },
    spacer2: {
        height: 16,
    },
    spacer3: {
        height: 80,
    },
})

export default styles
